import { render, staticRenderFns } from "./RecentTrades.vue?vue&type=template&id=1c325534&scoped=true"
import script from "./RecentTrades.vue?vue&type=script&lang=js"
export * from "./RecentTrades.vue?vue&type=script&lang=js"
import style0 from "./RecentTrades.vue?vue&type=style&index=0&id=1c325534&prod&lang=scss&scoped=true"
import style1 from "./RecentTrades.vue?vue&type=style&index=1&id=1c325534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c325534",
  null
  
)

export default component.exports